import React from 'react';
import ShopOrderRowProperties from "./ShopOrderRowProperties";
import ViewMedium from "../../../ui_components/MediaView/ViewMedium";
import ShopOrderRowMedium from "./ShopOrderRowMedium";
import ViewLarge from "../../../ui_components/MediaView/ViewLarge";
import ViewSmall from "../../../ui_components/MediaView/ViewSmall";
import ShopOrderRowSmall from "./ShopOrderRowSmall";


const ShopOrderRow: React.FC<ShopOrderRowProperties> = ({
                                                                    shopOrder,
                                                                    selectedDeliveryOrderIds,
                                                                    onShopOrderSelect,
                                                                    onUpdate,
                                                                    filter,
                                                                    from,
                                                                    to,
                                                                }) => {
    return (
        <>
            <ViewSmall>
                <ShopOrderRowSmall onUpdate={onUpdate} onShopOrderSelect={onShopOrderSelect}
                                       shopOrder={shopOrder}
                                       selectedDeliveryOrderIds={selectedDeliveryOrderIds}
                                       filter={filter} from={from} to={to}/>
            </ViewSmall>
            <ViewMedium>
                <ShopOrderRowMedium onUpdate={onUpdate} onShopOrderSelect={onShopOrderSelect}
                                        shopOrder={shopOrder}
                                        selectedDeliveryOrderIds={selectedDeliveryOrderIds}
                                        filter={filter} from={from} to={to}/>
            </ViewMedium>
            <ViewLarge>
                <ShopOrderRowMedium onUpdate={onUpdate} onShopOrderSelect={onShopOrderSelect}
                                        shopOrder={shopOrder}
                                        selectedDeliveryOrderIds={selectedDeliveryOrderIds}
                                        filter={filter} from={from} to={to}/>
            </ViewLarge>
        </>
    )
}

export default ShopOrderRow;
